import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BACKEND_URL } from "../constants";

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: BACKEND_URL,
        prepareHeaders: (headers, {}) => {
            headers.set('Content-Type', 'application/json')
            headers.set('Accept', 'application/json')
            headers.set('Cache-Control', 'no-cache')
            return headers
        },
    }),
    tagTypes: ['Auth'],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (body) => ({ 
                url: `auth/login`,
                method: 'POST',
                body: body,
            }),
            transformResponse: (response, meta, arg) => response,
        }),
        register: builder.mutation({
            query: (body) => ({ 
                url: `auth/register`,
                method: 'POST',
                body: body,
            }),
            transformResponse: (response, meta, arg) => response,
        }),
    }),
})

export const { 
    useLoginMutation,
    useRegisterMutation,
} = authApi